<template>
  <collapse :active-index="0">
    <collapse-item>
      <template slot="title">
        <div class="row">
          <div class="col">
            <h3 class="mb-0">Seguimientos</h3>
          </div>

          <div class="col text-right pr-5"></div>
        </div>
      </template>

      <ul class="list-group list-group-flush list my--3">
        <li v-for="activity in activities" :key="activity.id" class="list-group-item px-0">
          <div class="row">
            <div class="col text-right">
              <badge class="medium mb-1" :type="activity.state.color"> {{ activity.state.label }}</badge>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-4">
              <p class="h5 mb-0">Fecha de Seguimiento</p>
              <div class="h3 font-weight-300">{{ activity.date | date }}</div>
              <div v-if="activity.nextFollowUpDate && activity.nextFollowUpDate !== ''">
                <p class="h5 mb-0">Proximo Seguimiento</p>
                <div class="medium mb-2">{{ activity.nextFollowUpDate | date }}</div>
              </div>

              <div v-if="activity.user">
                <p class="h5 mb-0">Autor</p>
                <div class="medium mb-2">{{ activity.user.name }}</div>
              </div>

              <div>
                <p class="h5 mb-0">Cantidad</p>
                <div v-if="activity.quantity" class="medium mb-2">{{ activity.quantity }}</div>
                <div v-else class="medium mb-2">---</div>
              </div>
            </div>

            <div class="col">
              <!--              <p class="h5 mb-0">Comentario</p>-->
              <div v-if="activity.comment && activity.comment !== ''" class="medium mb-2">{{ activity.comment }}</div>
              <div v-else>&lt;sin comentario&gt;</div>
            </div>
          </div>
        </li>

        <li v-if="activities.length === 0" class="list-group-item px-0">
          <div class="row align-items-center">
            <div class="col">
              <h4 class="mb-0">Esta Proyección no tiene Seguimientos cargados.</h4>
            </div>
          </div>
        </li>
      </ul>
    </collapse-item>
  </collapse>
</template>

<script>
import Collapse from '@/components/Collapse/Collapse';
import CollapseItem from '@/components/Collapse/CollapseItem';

export default {
  components: {
    Collapse,
    CollapseItem,
  },

  props: {
    projection: null,
  },

  data() {
    return {
      activities: [],
      collapsed: -1,
    };
  },

  created() {
    const parameters = {
      include: ['state', 'user'],
    };

    this.$services
      .resource('projection_activities')
      .setProjection(this.projection.id)
      .get(parameters)
      .then((res) => res.data.data)
      .then((data) => {
        this.activities = data.activities;
      });
  },

  methods: {
    addActivity(activity) {
      this.activities.push(activity);
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .card-header {
  padding: 1.25rem 1.5rem !important;
}
</style>
